import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import axiosApiInstance from './apis/axiosInstance'
import { onMounted, computed, ref } from 'vue'
import { useMainStore, useInterfaceLanguageStore, useMediaManagerStore, useFolderStore } from './stores'
import { useInriApp, dialog } from '@inriver/inri'
import PreviewDialog from '@/components/dialogs/PreviewDialog.vue'
import FileUploadDialog from '@/components/dialogs/FileUploadDialog.vue'
import Drawer from '@/components/drawer/Drawer.vue'
import { getPortalBaseUrl } from './apis/mediaManagerApi'

// State etc

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const mainStore = useMainStore()
const interfaceLanguageStore = useInterfaceLanguageStore()
const mediaManagerStore = useMediaManagerStore()
const folderStore = useFolderStore()
const storesInitialized = computed(() => mainStore.initialized && mediaManagerStore.initialized && folderStore.initialized)
const hasError = ref(false)

// TODO: These are just for show. Needs proper data (available apps, permissions, links etc.)
const headerLinks = [
  {
    text: 'enrich',
    href: '#',
  },
  {
    text: 'plan & release',
    href: '#',
  },
  {
    text: 'syndicate',
    href: '#',
  },
  {
    text: 'evaluate',
    href: '#',
  },
  {
    text: 'planner',
    href: '#',
  },
  {
    text: 'supplier onboarding',
    href: '#',
  },
  {
    text: 'content store',
    href: '#',
  },
  {
    text: 'control center',
    href: '#',
  },
  {
    text: 'media',
    href: '#',
    isActive: true,
  },
]

useInriApp()

// Get initial data
onMounted(async () => {
  try {
    const customerResponse = await axiosApiInstance.get('/api/customerenvironment')
    if (typeof (customerResponse.data) === 'string') {
      const redirectToPortal = await getPortalBaseUrl()
      mainStore.redirectWithOutNotify(redirectToPortal)
    }
    const response = await axiosApiInstance.get('/api/appconfig')
    const data = response.data
    await mainStore.init(data)
    await interfaceLanguageStore.init(data.user.interfaceLanguageCode)
    await mediaManagerStore.init(data)
    await folderStore.init()
  } catch (ex: any) {
    hasError.value = true
    dialog.info(
      {
        title: 'Error',
        text: ex.toString(),
      },
    )
  }
})

return (_ctx: any,_cache: any) => {
  const _component_c_tile_btn = _resolveComponent("c-tile-btn")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_c_header_links = _resolveComponent("c-header-links")!
  const _component_c_drawer_button = _resolveComponent("c-drawer-button")!
  const _component_c_header = _resolveComponent("c-header")!
  const _component_c_page_container = _resolveComponent("c-page-container")!
  const _component_q_layout = _resolveComponent("q-layout")!
  const _component_c_page_spinner = _resolveComponent("c-page-spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_layout, { view: "hHh LpR fFf" }, {
      default: _withCtx(() => [
        _createVNode(_component_c_header, null, {
          default: _withCtx(() => [
            _createVNode(_component_c_tile_btn, {
              icon: "inri-inriver",
              color: "primary",
              "icon-size": "46",
              to: "/",
              loading: !_unref(storesInitialized),
              "aria-label": "inriver"
            }, null, 8, ["loading"]),
            _createVNode(_component_q_space),
            _createVNode(_component_c_header_links, { links: headerLinks }),
            _createVNode(_component_c_drawer_button)
          ]),
          _: 1
        }),
        (_unref(storesInitialized))
          ? (_openBlock(), _createBlock(Drawer, { key: 0 }))
          : _createCommentVNode("", true),
        (_unref(storesInitialized))
          ? (_openBlock(), _createBlock(_component_c_page_container, { key: 1 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(PreviewDialog),
    _createVNode(FileUploadDialog),
    (!hasError.value)
      ? (_openBlock(), _createBlock(_component_c_page_spinner, {
          key: 0,
          showing: !_unref(storesInitialized)
        }, null, 8, ["showing"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})